/**
 * Design tokens — typography, spacing, radii.
 *
 * Use these constants instead of magic numbers in StyleSheets.
 * Adoption is incremental; new code should use tokens, existing
 * code migrates over time.
 */

/** Typography scale (font sizes) */
export const FONT = {
  /** 10px — fine print, badges */
  xs: 10,
  /** 12px — captions, metadata, chips */
  sm: 12,
  /** 14px — body text, list items */
  base: 14,
  /** 16px — prominent body, inputs */
  md: 16,
  /** 18px — section headers */
  lg: 18,
  /** 20px — screen titles */
  xl: 20,
  /** 24px — hero numbers */
  '2xl': 24,
  /** 32px — large hero */
  '3xl': 32,
  /** 42px — score display */
  '4xl': 42,
} as const;

/** Font weight presets */
export const WEIGHT = {
  normal: '400' as const,
  medium: '500' as const,
  semibold: '600' as const,
  bold: '700' as const,
  extrabold: '800' as const,
  black: '900' as const,
};

/** Spacing scale (padding, margin, gap) */
export const SPACE = {
  /** 2px */
  '0.5': 2,
  /** 4px */
  '1': 4,
  /** 6px */
  '1.5': 6,
  /** 8px */
  '2': 8,
  /** 12px */
  '3': 12,
  /** 16px */
  '4': 16,
  /** 20px */
  '5': 20,
  /** 24px */
  '6': 24,
  /** 32px */
  '8': 32,
  /** 48px */
  '12': 48,
  /** 64px */
  '16': 64,
} as const;

/** Border radius presets */
export const RADIUS = {
  /** 4px — subtle rounding */
  sm: 4,
  /** 8px — cards, inputs */
  md: 8,
  /** 12px — larger cards, modals */
  lg: 12,
  /** 16px — chips */
  xl: 16,
  /** 999px — pill / circular */
  full: 999,
} as const;
